import { render, staticRenderFns } from "./footerVue.vue?vue&type=template&id=5d0cafc2&scoped=true"
import script from "./footerVue.vue?vue&type=script&lang=js"
export * from "./footerVue.vue?vue&type=script&lang=js"
import style0 from "./footerVue.vue?vue&type=style&index=0&id=5d0cafc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0cafc2",
  null
  
)

export default component.exports